import { useColorModeValue } from "@chakra-ui/react";
import { useColorMode } from "@chakra-ui/react";

const useDarkStyles = () => {
    const { colorMode } = useColorMode();

    return {
        singleValue: (styles) => ({
            ...styles,
            backgroundColor: 'transparent',
            color: colorMode === 'dark' ? "white" : "black",
            borderColor: useColorModeValue("gray.200", "gray.600"),
        }),
        control: (styles) => ({
            ...styles,
            backgroundColor: 'transparent',
            color: colorMode === 'dark' ? "white" : "black",
            borderColor: useColorModeValue("gray.200", "gray.600"),
        }),
        menu: (styles) => ({
            ...styles,
            backgroundColor: colorMode === 'dark' ? '#1A202C' : '#fff',
        }),
        multiValue: (styles) => {
            return {
              ...styles,
              backgroundColor: (colorMode === "dark" ? '#2D3748' : '#E2E8F0'),
            };
          },
          multiValueLabel: (styles) => ({
            ...styles,
            color: (colorMode === "dark" ? '#fff' : '#000'),
          }),
        option: (styles, {isSelected, isFocused}) => {
            return {
                ...styles,
                backgroundColor: isSelected ? (colorMode === "dark" ? '#51555e' : '#9da6b0') : (isFocused ? (colorMode === "dark" ? "#1F2733" : '#CBD5E0') : (colorMode === "dark" ? '#1A202C' : '#fff')),
                color: colorMode === "dark" ? "white" : "black",
            };
        },
        input: (styles) => ({
            ...styles,
            color: colorMode === 'dark' ? "white" : "black",
        }),
    };
}
export default useDarkStyles;